import styles from './versionDropDown.module.scss'
import { compareVersions } from 'compare-versions'
import React from 'react'

function VersionDropDown({
    currentVersion,
    handleVersionChange,
    moduleVersions,
}: {
    currentVersion: string
    handleVersionChange: (event: React.ChangeEvent<HTMLSelectElement>) => null
    moduleVersions: ModuleObject[]
}) {
    const moduleVersionsSorted = moduleVersions.sort(
        (a, b) => compareVersions(a.version, b.version) * -1
    )

    return (
        <span className={styles.verNoHeader}>
            <label htmlFor="versionSelect">version:</label>
            <select
                className={styles.versionSelect}
                id="versionSelect"
                name="versionSelect"
                onChange={handleVersionChange}
                value={currentVersion}
                data-testid="select"
            >
                {moduleVersionsSorted.map((module, key) => (
                    <option
                        data-testid="select-option"
                        value={module.version}
                        key={'option' + key}
                    >
                        {module.version}
                        {key === 0 && <> (latest)</>}
                    </option>
                ))}
            </select>
        </span>
    )
}

export default VersionDropDown
